export default String.raw`
.blog-item {
    &__title {
        @include h4-headline;
    }

    &__content {
        margin: 0 0 8px 0;
    }

    &__read {
        position: relative;
        flex-direction: row;
        justify-content: space-between;
        &-top {
            flex-direction: column;
            row-gap: 16px;
            &-tags {
                width: 100%;
                order: 1;
            }
            time {
                order: 2;
                position: relative;
                bottom: 2px;
            }
        }
        &-bottom {
            justify-content: end;
            align-items: end;
            &-time {
                display: none;
            }
            &-button {
                position: absolute;
            }
        }
    }
}
`